import apiInstance from "api";

/**
 * Per-org entitlements + usage-meter checks + admin sync. Backed by flex2-api PR-3 + PR-1b.
 * Use `check` for gating decisions in the UI ("should I show this button?").
 */
export const EntitlementsApiService = {
  list: (organizationId) =>
    apiInstance.get(`/entitlements`, { params: organizationId ? { organizationId } : {} }),
  check: (featureKey) =>
    apiInstance.get(`/entitlements/check`, { params: { featureKey } }),
  upsert: (body) => apiInstance.post(`/entitlements`, body),
  remove: (id) => apiInstance.delete(`/entitlements/${id}`),

  // ── Admin sync (reconcile from SubscriptionFeature catalog) ─────
  syncAll: (prune = true) => apiInstance.post(`/admin/entitlements/sync`, null, { params: { prune } }),
  syncOrg: (organizationId, prune = true) =>
    apiInstance.post(`/admin/entitlements/sync/org/${organizationId}`, null, { params: { prune } }),
  syncSubscription: (subscriptionId) =>
    apiInstance.post(`/admin/entitlements/sync/subscription/${subscriptionId}`),
};

export default EntitlementsApiService;
